import Auth from "@/services/LandingAuth"
import Http from "@/services/api/util/http-internal"
import Repo from "@/services/api/util/auth-repo-local-storage"

const instance = new Auth(new Repo(), new Http(), process.env.VUE_APP_LANDING_AUTH)
Object.freeze(instance)
export default instance